import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ReduxState } from '../store'
import { AuthState } from './reducer'
import { bootAuthenticatedUser } from './operations'

export type UseSignInResult = [
  AuthState,
  () => Promise<boolean>
]

export const useBootstrap = (): UseSignInResult => {
  const dispatch = useDispatch()
  const signInState = useSelector<ReduxState, AuthState>((state) => state.auth)

  const connectedBootstrap = useCallback(() => {
    return bootAuthenticatedUser()(dispatch)
  }, [dispatch])

  return [signInState, connectedBootstrap]
}
